export const colors = {
  primaryColor: "dodgerblue",
  grey: "#aaaaaa",
  black: "#323232",
};
